import React from "react";
import { Form, Space } from "antd";
import MasterImagePicker from "./MasterImagePicker";
import MasterMultiImagePicker from "./MasterMultiImagePicker";
import ImageClipboardActions from "./ImageClipboardActions";

const MasterImagePickerField = ({
  form,
  name,
  label,
  multiple = false,
  maxPhotos = 10,
  copyLabel = "Copy ảnh",
  pasteLabel = "Dán từ clipboard",
  style,
}) => {
  const value = Form.useWatch(name, form);

  const appendToGallery = (img) => {
    const current = Array.isArray(form.getFieldValue(name)) ? form.getFieldValue(name) : [];
    const exists = current.some((x) => x?.id === img?.id || x?.url === img?.url);
    if (!exists && img) {
      const limited = [img, ...current].slice(0, Math.max(1, Number(maxPhotos) || 10));
      form.setFieldValue(name, limited);
    }
  };

  const currentClipboardImage = multiple
    ? Array.isArray(value)
      ? value[0] || null
      : null
    : value || null;

  return (
    <Space direction="vertical" style={{ width: "100%", ...(style || {}) }} size={8}>
      <Form.Item name={name} label={label} style={{ marginBottom: 0 }}>
        {multiple ? <MasterMultiImagePicker maxPhotos={maxPhotos} /> : <MasterImagePicker />}
      </Form.Item>

      <ImageClipboardActions
        image={currentClipboardImage}
        onSetImage={multiple ? undefined : (img) => form.setFieldValue(name, img || null)}
        onAppendImage={multiple ? appendToGallery : undefined}
        copyLabel={copyLabel}
        pasteLabel={pasteLabel}
      />
    </Space>
  );
};

export default MasterImagePickerField;